import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { assets } from "../../../Assets/assets";
import LabelHeading from "../../common/LabelHeading";
import ScrollArrowButtons from "../../common/ScrollArrowButtons";

const Testimonials = () => {
  const [itemsPerSlide, setItemsPerSlide] = useState(3);
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  const testimonials = [
    {
      name: "Jatin Mishra",
      role: "Web Developer",
      img: assets.profile,
      text: "Natio Infotech Pvt Ltd helped us hire skilled candidates quickly. Their process is smooth, transparent, and truly client-focused.",
    },
    {
      name: "Aman singh",
      role: "Web Developer",
      img: assets.profile,
      text: "Exceptional service and smooth coordination. Natio Infotech Pvt Ltd helped us scale our team with qualified professionals quickly and efficiently.",
    },
    {
      name: "Stalin patel",
      role: "Web Developer",
      img: assets.profile,
      text: "We appreciate their communication, speed, and ability to match the right talent to the right role. Natio Infotech Pvt Ltd has been a great hiring partner.",
    },
    {
      name: "Soumya roy",
      role: "Web Developer",
      img: assets.profile,
      text: "Professional, reliable, and results-oriented — Natio Infotech Pvt Ltd exceeded our hiring expectations and saved us weeks of effort.",
    },
    {
      name: "Ashish panda",
      role: "Web Developer",
      img: assets.profile,
      text: "Their recruitment process is well-structured, transparent, and responsive. We found highly skilled candidates thanks to Natio Infotech Pvt Ltd.",
    },
    {
      name: "Kalpataru behera",
      role: "Web Developer",
      img: assets.profile,
      text: "Working with Natio Infotech Pvt Ltd was effortless and efficient. They understood our requirements perfectly and delivered top-talent faster than expected.",
    },
  ];

  useEffect(() => {
    const updateVisibleItems = () => {
      if (window.innerWidth < 640) setItemsPerSlide(1);
      else if (window.innerWidth < 1024) setItemsPerSlide(2);
      else setItemsPerSlide(3);
    };

    updateVisibleItems();
    window.addEventListener("resize", updateVisibleItems);
    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

  const startAuto = () => {
    stopAuto();
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 4000);
  };

  const stopAuto = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAuto();
    return stopAuto;
  }, [itemsPerSlide, totalSlides]);

  const nextSlide = () => {
    stopAuto();
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    startAuto();
  };

  const prevSlide = () => {
    stopAuto();
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
    startAuto();
  };

  return (
    <section
      className="relative bg-cover bg-center pb-20 pt-10"
      style={{ backgroundImage: `url(${assets.testimonialbg})` }}
    >
      <div className="max-w-[1400px] px-6 mx-auto">
        <LabelHeading
          label="Customer Testimonials"
          heading="What Saying Our Customers"
          position="left"
        />

        <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-end gap-3 mb-4">
          <ScrollArrowButtons scrollLeft={prevSlide} scrollRight={nextSlide} />
        </div>

        <div
          className="overflow-hidden"
          onMouseEnter={stopAuto}
          onMouseLeave={startAuto}
        >
          <motion.div
            animate={{ x: `-${currentSlide * 100}%` }}
            transition={{ type: "spring", duration: 0.6 }}
            className="flex"
          >
            {Array.from({ length: totalSlides }, (_, slideIndex) => (
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={slideIndex * 100}
                key={slideIndex}
                className="min-w-full flex justify-center gap-6 flex-wrap"
              >
                {testimonials
                  .slice(
                    slideIndex * itemsPerSlide,
                    (slideIndex + 1) * itemsPerSlide
                  )
                  .map((item, i) => (
                    <div
                      key={i}
                      className="bg-white text-black rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 w-full sm:w-[48%] lg:w-[32%]"
                    >
                      <p className="text-gray-600 leading-relaxed text-[15px]">
                        {item.text}
                      </p>

                      <div className="mt-6 flex items-center gap-4">
                        <div className="w-14 h-14 rounded-full bg-gray-300 flex items-center justify-center text-xl font-bold">
                          {item.name?.charAt(0)}
                        </div>
                        <div>
                          <h3 className="font-semibold text-[16px]">
                            {item.name}
                          </h3>
                          <p className="text-gray-500">{item.role}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </motion.div>
        </div>

        <div className="flex justify-center gap-3 mt-6">
          {Array.from({ length: totalSlides }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentSlide(i)}
              className={`w-3 h-3 rounded-full transition-all ${currentSlide === i
                ? "bg-primaryColor scale-125"
                : "bg-gray-400"
                }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
